import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonBase, Tooltip } from '@mui/material';
import './UnprocessedItemsButton.css';

function WarningTriangleIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
      <path d="M12 9v4.5" />
      <path d="M12 17.2h.01" />
    </svg>
  );
}

/**
 * Chip shown when the client has unprocessed documents.
 * Red pulse, bold; click opens UnprocessedItemsModal.
 * Shows total unprocessed + count for the currently selected reporting month/range.
 */
export default function UnprocessedItemsButton({
  totalCount,
  dateCount,
  dateLabel,
  onClick,
  disabled,
}) {
  const { t, i18n } = useTranslation();

  if (totalCount == null || totalCount <= 0) {
    return null;
  }

  const showDateBadge = dateCount != null && dateLabel;

  return (
    <ButtonBase
      className="unprocessed-items-button"
      onClick={onClick}
      disabled={disabled}
      dir={i18n.dir()}
      focusRipple
    >
      <span className="unprocessed-items-button__icon">
        <WarningTriangleIcon />
      </span>

      <span className="unprocessed-items-button__title">
        {t('DocumentsAwaitingTreatment')}
      </span>

      <span className="unprocessed-items-badges">
        <Tooltip title={t('UnprocessedTotalTooltip', { defaultValue: t('Total') })}>
          <span className="unprocessed-items-badge unprocessed-items-badge--total">
            <span className="unprocessed-items-badge__hint">{t('Total')}</span>
            {totalCount}
          </span>
        </Tooltip>
        {showDateBadge && (
          <Tooltip
            title={t('UnprocessedSelectedMonthTooltip', {
              month: dateLabel,
              defaultValue: dateLabel,
            })}
          >
            <span className="unprocessed-items-badge unprocessed-items-badge--month">
              <span className="unprocessed-items-badge__hint">{dateLabel}</span>
              {dateCount}
            </span>
          </Tooltip>
        )}
      </span>
    </ButtonBase>
  );
}
